<template>
  <div :class='classes'>
    <button v-for='{disabled,toy} in toys'
            class="flex flex-col shadow-sm rounded hover:border-gray-600 ml-1 border-box flex-none w-16 h-16 overflow-hidden border-blue-800 focus:outline-none pt-2 relative"
            @click="select(toy)"
            :class='isSelectedClass(toy, disabled)'
            :disabled='disabled'
            :key='toy.id'>

        <img :src='makeThumbnailUrl(toy.thumbnailImage)' class='object-contain w-12 h-12' />
        <slot name='toy' v-bind:toy='toy' />

    </button>

  </div>
</template>
<script>
export default {
  inject: ['api'],
  props:{
    toys:{
      type: Array,
      required: true
    },
    classes: {
      type: String,
      default: 'flex flex-row justify-center h-16'
    }
  },
  data() {
    return {
      selectedToy: {}
    }
  },
  methods: {
    makeThumbnailUrl(img) {
      return this.api.makeImageUrlEditor(img);
    },
    deselect() {
      this.selectedToy = {};
    },
    select(toy) {
      this.selectedToy = toy;
      this.$emit('select', toy);
    },
    isSelectedClass(toy, disabled) {
      let extraClass = disabled ? 'opacity-50' : '';
      if (this.selectedToy.id === toy.id) {
        return 'bg-blue-400 ' + extraClass;
      } else {
        return 'bg-blue-900 ' + extraClass;
      }
    }
  },
}
</script>

